import React from "react";
import { Component } from "react";
import Moment from 'moment';
import { Button } from "react-bootstrap";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions } from 'react-redux-form';

import { CustomDropdown } from '../../../../../common/custom-form/custom-dropdown.component';
import Translation from '../../../../../common/translation/translation.component';
import { CustomSearchableSelectKeyValue, InputField } from '../../../../../common/custom-form/input-filter-component';
import { ACTION_TYPES, MAX_LENGTH, Selected_Index } from '../../../../../../constants/external-constants';
import TableWithButton from '../../../../../common/details-table/table-with-button.component';
import { userCostAllocationActions } from '../../../../../../store/external/manage-user/form/user-add-cost-allocation.reducer';
import { NotificationModal } from "../../../../../common/modal/notification-modal.component";
import { hasObjectWithProperty, convertToTimeZoneDate } from "../../../../../../utils/helpers.utils";
import { CONFIRMATION_VALUE, TRANSLATIONS } from "../../../../../../utils/constant.utils";
import { ConfirmationModal } from "../../../../../common/modal/modal.component";
import { ConfirmationNotificationModal } from "../../../../../common/modal/confirmation-modal.component";
import CustomSearchableDropdownWrapper from "../../../../../common/custom-form/custom-dropdown/custom-searchable-dropdown-wrapper";

class AddCostAllocation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            inputValue: "",
            viewDetailPage: false,
            titleBtn: false,
            enableAddBtn: false,
            showCostAllocatioDetails: false,
            updateCostAllocationDetails: false,
            enableEdit: false,
            keyIndex: null,
            selectedGlCodeKey: "",
            selectedCostCenterKey: "",
            selectedValue: '',
            activeDropdown: false,
            showDetails: false,
            modalMessage: "",
            showModal: false,
            dataTable: [],
            glCodeValid: true,
            costCenterValid: true,
            isExist: false,
            isGreater: false,
            selectedGlCode: null,
            selectedCostCenter: null,
            fieldChange: false,
            glCode: "",
            costCenter: "",
            percent: "",
            loading: true,
            totalCostCodePercent: 0,
            percentValue: "",
            tableLength: 0,
            optionsMap: {
                "GLCode": [],
                "CostCode": []
            },
            selectedItems: {
                GLCode: "",
                GLCodeName: "",
                CostCode: "",
                CostCodePercent: "",
                CompanyCode: "",

            },
            data: {
                GLCode: '',
                CostCode: '',
                CostCodePercent: 0,
                GLCodeName: '',
                CompanyCode: '',
                CostCodeID: '',
                GLCodeID: '',
                LastModified: ''
            },
            showNotif: false,
            notifTitle: null,
            isAddPercent: false,
            isUpdatePercent: false,
            isUpdateGl_Cost: false,
            isAddGL_Cost: false,
        }
    }

    handleCancel = () => {
        this.toggleActiveState();

        this.props.resetCostAllocation();
        this.props.getGlCodeList(1, '', false);
        this.props.getCostCodeList(1, '', false)
        
        this.setState({
            glCode: '',
            costCenter: '',
            percent: '',
            updateCostAllocationDetails: false,
            enableEdit: false,
            keyIndex: null,
            isGreater: false,
            isExist: false,
            enableAddBtn: false,
            isAddPercent: false,
            isUpdatePercent: false,
            isAddGL_Cost: false,
            isUpdateGl_Cost: false,
        })
    }

    async componentDidMount() {
        const { userId, getAddCostAllocation, getGlCodeList, getCostCodeList, getCostCodeDetailList } = this.props;

        getAddCostAllocation(userId).then(() => {
            const { userCostAllocation } = this.props.manageUserCostAllocation;
            const tableLength = userCostAllocation?.datatable[0]?.dataItem?.length;
            this.setState({ tableLength })
        });;

        await getGlCodeList();
        await getCostCodeList();

        await this.props.getGlCodeList(1, null, true);
        await this.props.getCostCodeList(1, null, true);
    }

    showDetails(value) {
        this.setState({
            showDetails: value
        });
    }

    activateAddBtn() {
        if (this.state.glCode && this.state.costCenter && this.state.percent) {
            this.setState({ enableAddBtn: true });
        } else {
            this.setState({ enableAddBtn: false });
        }
    }

    HandleOnChange(e, field) {
        const { value } = e.target;
        if (value === '' || /^\d*(\.\d*)?$/.test(value)) {
            this.setState({ [field]: value }, () => {
                this.activateAddBtn();
            });
        }
    }

    OnChangeGlCode = (e) => {
        const { glCodeList } = this.props.manageUserCostAllocation

        const value = glCodeList.find(x => x.Key === e)?.Value;

        this.setState({
            selectedGlCodeKey: e,
            glCode: value,
            glCodeValid: true,
            isAddGLcode: false,
        }, () => {
            this.activateAddBtn()
        });
    };

    OnChangeCostCenter = (e) => {
        const { costCodeList } = this.props.manageUserCostAllocation
        //const value = e.text.split('~')[0].trim();
        //const companyCode = e.text.split('~')[1].trim();
        const value = costCodeList.find(x => x.Key === e)?.Value;
        const companyCode = costCodeList.find(x => x.Key === e)?.Label;

        this.props.FormChange(`manageUserCostAllocationForm.CompanyCode`, companyCode)
        this.props.FormChange(`manageUserCostAllocationForm.CostCenter`, value)
        this.setState({
            selectedCostCenterKey: e,
            costCenter: value,
            costCenterValid: true,
            isAddGL_Cost: false,
        }, () => {
            this.activateAddBtn()
        });

    };

    clearSelectedValue = () => {
        this.setState({
            selectedItems: {
                GLCode: "",
                GLCodeName: "",
                CostCode: "",
                CostCodePercent: "",
                CompanyCode: ""

            }
        });

        this.props.FormChange(`manageUserCostAllocationForm.Key`, 0);
    }

    updateUserCostAllocation = async (indexItem) => {
        let companyKey;
        const { manageUserCostAllocation, manageUserCostAllocationForm, manageUserCostAllocationTableForm } = this.props;
        const { CostCode: _costCode, GLCode: _glCode, Key } = manageUserCostAllocationTableForm;

        const currectCompanyCode = manageUserCostAllocation.userCostAllocation.datatable[0].dataItem[indexItem].CompanyCode;
        const currentKey = manageUserCostAllocation?.costCodeTableOption.find(option => option.Label === currectCompanyCode)

        if (Key === 0 || Key === null) {
            companyKey = currentKey?.Key;
        } else {
            companyKey = Key;
        }
        const _companyCode = manageUserCostAllocation?.costCodeTableOption.find(option => option.Key === companyKey)?.Label;;

        this.props.FormChange(`manageUserCostAllocationTableForm.CompanyCode`, _companyCode)

        if (manageUserCostAllocation.userCostAllocation.datatable.length > 0) {
            const costAllocationItems = await manageUserCostAllocation.userCostAllocation.datatable[0].dataItem.filter((item, index) => index !== indexItem);
            const isExisting = costAllocationItems.some(item => item.CostCodeID === _costCode && item.GLCodeID === _glCode && item.CompanyCode === _companyCode);

            if (isExisting) {
                this.setState({
                    haveError: true,
                    isExist: true,
                    showNotif: true,
                    isGreater: false,
                    isUpdateGl_Cost: true,
                    modalMessage: <Translation translationKey={"gl_cost_center_already_exist"} />
                });
                return
            } else {
                this.setState({
                    haveError: false,
                    isExist: false,
                    showNotif: false
                });
            }
        }

        var totalCostCodePercent = this.CalculateTotalCostCodePercent(manageUserCostAllocationTableForm.CostCodePercent ?? 0, indexItem);


        if (totalCostCodePercent > 100) {
            this.setState({
                haveError: true,
                modalMessage: <Translation translationKey={"percentage_cannot_exceed"} />,
                glCodeValid: false,
                costCenterValid: false,
                showNotif: true,
                isGreater: true,
                isExist: false,
                isAddPercent: false,
                isUpdatePercent: true,
                isUpdateGl_Cost: false,
            });
            return;
        }

        if (!this.state.haveError) {
            this.setState({
                showModal: true,
                keyIndex: indexItem,
                isGreater: false,
                updateCostAllocationDetails: true,
            })
        }


    }


    ResetError = (value) => {
        this.setState({
            haveError: value
        })
    }

    CalculateTotalCostCodePercent = (percent, indexItem) => {
        const { manageUserCostAllocation } = this.props;

        var costAllocationItems = [
            ...manageUserCostAllocation.userCostAllocation.datatable[0].dataItem
        ];
        if (indexItem > -1) {
            costAllocationItems.splice(indexItem, 1);
        }
        var totalCostCodePercent = 0;

        if (costAllocationItems.length > 0) {
            totalCostCodePercent = costAllocationItems.reduce(
                (total, item) => total + parseFloat(item.CostCodePercent),
                parseFloat(percent)
            );
        }
        else {
            totalCostCodePercent = parseFloat(percent);
        }
        return totalCostCodePercent;
    }

    AdduserCostAllocation = () => {
        const { activeTimeZoneOffset } = this.props.adminSetting;
        const {
            glCode, costCenter, percent, selectedCostCenterKey,
            selectedGlCodeKey, haveError
        } = this.state;

        const {
            manageUserCostAllocation,
            manageUserCostAllocationForm
        } = this.props;
        const newCompanyCode = manageUserCostAllocationForm.CompanyCode;
        this.props.FormChange(`manageUserCostAllocationForm.CompanyCode`, newCompanyCode)
        const { CompanyCode: _companyCode } = manageUserCostAllocationForm;
        const dataItem = manageUserCostAllocation.userCostAllocation.datatable?.[0]?.dataItem || [];

        const data = {
            GLCode: glCode,
            CostCode: costCenter,
            CostCodePercent: percent,
            GLCodeName: '',
            CompanyCode: '',
            CostCodeID: selectedCostCenterKey,
            GLCodeID: selectedGlCodeKey,
            LastModified: `${sessionStorage.FirstName} ${sessionStorage.LastName} on ${Moment(convertToTimeZoneDate(new Date(), activeTimeZoneOffset?.UtcOffset)).format('L')} ${Moment(convertToTimeZoneDate(new Date(), activeTimeZoneOffset?.UtcOffset)).format('LT')}`,
        };

        const itemExists = dataItem.some(item =>
            item.CostCodeID === data.CostCodeID &&
            item.GLCodeID === data.GLCodeID &&
            item.CompanyCode === _companyCode
        );

        if (itemExists) {
            this.setState({
                haveError: true,
                isExist: true,
                showNotif: true,
                isGreater: false,
                isAddGL_Cost: true,
                modalMessage: <Translation translationKey={"gl_cost_center_already_exist"} />
            });
            return;
        }

        const totalCostCodePercent = this.CalculateTotalCostCodePercent(percent);

        if (totalCostCodePercent > 100) {
            this.setState({
                haveError: true,
                showNotif: true,
                modalMessage: <Translation translationKey={"percentage_cannot_exceed"} />,
                isGreater: true,
                isExist: false,
                isAddPercent: true,
                isUpdatePercent: false,
            });
            return;
        }

        if (!haveError) {
            this.setState({
                showModal: true,
                updateCostAllocationDetails: false,
                totalCostCodePercent: totalCostCodePercent,
                data: data
            });
        } else {
            this.setState({
                haveError: false,
                isExist: false,
                showNotif: false,
                modalMessage: ""
            });
        }
    };

    DeleteuserCostAllocation = (index) => {
        const { userCostAllocation } = this.props.manageUserCostAllocation;

        this.props.deleteCostAllocationDetails(index);

        const updateCostList = userCostAllocation
        let newTable = updateCostList?.datatable[0]?.dataItem;

        newTable.splice(index, 1);
    };


    handleGetFieldData = (field, data) => {

        const { glCodeTableOption, costCodeTableOption } = this.props.manageUserCostAllocation;
    
        if (field === "GLCode") {
            const fullGlCodeOptions = glCodeTableOption || [];
            const glCodeOption = { Key: data.GLCodeID, Value: data.GLCode, Label: data.GLCodeName };
            
            const optionExists = fullGlCodeOptions.some(opt => opt.Key === glCodeOption.Key);
    
            const finalOptions = optionExists ? fullGlCodeOptions : [glCodeOption, ...fullGlCodeOptions];
            
            this.setState(prevState => ({
                optionsMap: {
                    ...prevState.optionsMap,
                    "GLCode": finalOptions
                }
            }));
    
            this.props.FormChange(`manageUserCostAllocationTableForm.GLCode`, data.GLCodeID);
            this.props.FormChange(`manageUserCostAllocationTableForm.GLCodeID`, data.GLCodeID);
            this.props.FormChange(`manageUserCostAllocationTableForm.GLCodeName`, data.GLCodeName);

        } else if (field === "CostCode") {
            const fullCostCodeOptions = costCodeTableOption || [];
            const costCodeOption = { Key: data.CostCodeID, Value: data.CostCode, Label: data.CompanyCode };
            
            const optionExists = fullCostCodeOptions.some(opt => opt.Key === costCodeOption.Key);
    
            const finalOptions = optionExists ? fullCostCodeOptions : [costCodeOption, ...fullCostCodeOptions];
            
            this.setState(prevState => ({
                optionsMap: {
                    ...prevState.optionsMap,
                    "CostCode": this.modifyOption(finalOptions)
                }
            }));
            
            this.props.FormChange(`manageUserCostAllocationTableForm.CostCode`, data.CostCodeID);
            this.props.FormChange(`manageUserCostAllocationTableForm.CostCodeID`, data.CostCodeID);
            this.props.FormChange(`manageUserCostAllocationTableForm.CompanyCode`, data.CompanyCode);

        } else if (field === "CostCodePercent") {
            this.props.FormChange(`manageUserCostAllocationTableForm.CostCodePercent`, data.CostCodePercent);
        }
    }

    handleSelectChange = (field, e, index) => {
       
        const newKey = e?.Key ?? e;
    
        this.props.FormChange(`manageUserCostAllocationTableForm.${field}`, newKey);
    
        if (field === "GLCode") {
            const { glCodeTableOption } = this.props.manageUserCostAllocation;
            const selectedLabel = glCodeTableOption.find(option => option.Key === newKey)?.Label;
            this.props.FormChange(`manageUserCostAllocationTableForm.GLCodeName`, selectedLabel);

        } else if (field === "CostCode") {
            const { costCodeTableOption } = this.props.manageUserCostAllocation;
            const companyCode = costCodeTableOption.find(x => x.Key === newKey)?.Label;
            this.props.FormChange(`manageUserCostAllocationTableForm.CompanyCode`, companyCode);
            this.props.FormChange(`manageUserCostAllocationTableForm.Key`, newKey);
        }
    };

    handleInputChange(field, e) {
        var value = e.target.value;
        if (value === '' || /^\d*\.?\d*$/.test(value)) {
            this.props.FormChange(`manageUserCostAllocationTableForm.${field}`, value)
            this.setState(prevState => ({
                ...prevState,
                selectedItems: {
                    ...prevState.selectedItems,
                    [field]: value
                },
                fieldChange: true,
                percentValue: value
            }));
        }
    };

    handleConfirmationModal = (buttonType) => {
        const { updateUserCostAllocationItem } = this.props;
        const { keyIndex } = this.state
        if (buttonType === CONFIRMATION_VALUE.Ok) {
            if (this.state.updateCostAllocationDetails) {
                updateUserCostAllocationItem(keyIndex);
            } else {
                this.props.addCostAllocationDetails(this.state.data, this.state.totalCostCodePercent);
                this.props.resetCostAllocation();
                this.setState({
                    glCode: '',
                    costCenter: '',
                    percent: '',
                    enableAddBtn: false,
                });
            }

            this.setState(prev => ({
                showModal: !prev.showModal,
                enableEdit: false,
                updateCostAllocationDetails: false,
                isExist: false,
                isGreater: false
            }))

        } else {
            this.setState({
                showModal: false
            });
        }
        
        this.props.getGlCodeList(1, '', false);
        this.props.getCostCodeList(1, '', false);
    }

    handleCloseNotif = () => {
        this.setState({ showNotif: false });
    }

    handleOpenNotif = (title) => {
        this.setState({
            showNotif: true,
            notifTitle: title
        });
    }

    onClickAdd = async () => {
        this.AdduserCostAllocation()

        await this.props.getGlCodeList();
        await this.props.getCostCodeList();
    }

    modifyOption = (options) => {
        if (options) {
            return options.map(option => ({
                ...option,
                Value: `${option.Value} ~ ${option.Label}`
            }));
        }
    }

    formatTotalCostCodePercent(totalCostCodePercent) {
        if (Number.isInteger(totalCostCodePercent)) {
            return `${totalCostCodePercent}%`;
        } else {
            const decimalPart = totalCostCodePercent.toString().split('.')[1];
            const decimalPlaces = decimalPart ? Math.min(decimalPart.length, 50) : 0;
            return `${totalCostCodePercent.toFixed(decimalPlaces)}%`;
        }
    }

    toggleActiveState = () => {
        this.setState(prevState => ({ activeDropdown: !prevState.activeDropdown }));
    }

    handelEnableEdit = (enable, index) => {
        this.setState({ enableEdit: enable, keyIndex: index })
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return TRANSLATIONS[TRANSLATIONS['defaultLocaleLanguage']][key];

        return TRANSLATIONS[locale][key];
    }

    handleCostCodeSearch = async (query) => {
        await this.props.getCostCodeList(1, query);
    }

    loadMoreCostCode = async (searchString) => {
        const { costCodePage } = this.props.manageUserCostAllocation;
        await this.props.getCostCodeList(costCodePage + 1, searchString);
    }

    handleGlCodeSearch = async (query) => {
        await this.props.getGlCodeList(1, query);
    }

    loadMoreGlCode = async (searchString) => {
        const { glCodePage } = this.props.manageUserCostAllocation;
        await this.props.getGlCodeList(glCodePage + 1, searchString);
    }

    onTableSearchChange = async (query, propName) => {
        if (propName === "GLCode") {
            await this.props.getGlCodeList(1, query, true);
            const { glCodeTableOption } = this.props.manageUserCostAllocation;

            this.setState(prevState => ({
                optionsMap: {
                    ...prevState.optionsMap,
                    "GLCode": glCodeTableOption
                }
            }));
        }
        else if (propName === "CostCode") {
            await this.props.getCostCodeList(1, query, true);
            const { costCodeTableOption } = this.props.manageUserCostAllocation;

            this.setState(prevState => ({
                optionsMap: {
                    ...prevState.optionsMap,
                    "CostCode": this.modifyOption(costCodeTableOption)
                }
            }));
        }
    }
    onTableLoadMore = async (searchString, propName) => {
        if (propName === "GLCode") {
            const { glCodePage, glCodeTableOption, limitRenderGlCode } = this.props.manageUserCostAllocation;

            if (limitRenderGlCode === 1) {
                await this.props.getGlCodeList(glCodePage + 1, searchString, true, 1);
            }
            
            this.setState(prevState => ({
                optionsMap: {
                    ...prevState.optionsMap,
                    "GLCode": glCodeTableOption
                }
            }));
        }
        else {
            const { costCodePage, costCodeTableOption, limitRenderCostCode } = this.props.manageUserCostAllocation;

            if (limitRenderCostCode === 1) {
                await this.props.getCostCodeList(costCodePage + 1, searchString, true, 1);
            }
            
            this.setState(prevState => ({
                optionsMap: {
                    ...prevState.optionsMap,
                    "CostCode": this.modifyOption(costCodeTableOption)
                }
            }));
        }
    }
    isTableDropDownLoading = (propName) => {
        const { isCostCodeLoading, isGlCodeLoading } = this.props.manageUserCostAllocation;

        return propName === "GLCode" ? isGlCodeLoading : isCostCodeLoading
    }
    hasTableDropdownMore = (propName) => {
        const { hasMoreCostCode, hasMoreGlCode } = this.props.manageUserCostAllocation;

        return propName === "GLCode" ? hasMoreGlCode : hasMoreCostCode
    }
    setCostAllocationForm = (propName) => {
        const { manageUserCostAllocationTableForm } = this.props;
        return propName === "GLCode" ? manageUserCostAllocationTableForm.GLCode : manageUserCostAllocationTableForm.CostCode;
    }

    handleEditModeEnter = async () => {
        await this.props.getGlCodeList(1, null, true);
        await this.props.getCostCodeList(1, null, true);
    }

     preloadTableOptions = () => {
        const { glCodeTableOption } = this.props.manageUserCostAllocation;
        if (!glCodeTableOption || glCodeTableOption.length === 0) {
            this.props.getGlCodeList(1, null, true);
            this.props.getCostCodeList(1, null, true);
        }
    }

    resetTableForm = () => {
        this.props.FormChange('manageUserCostAllocationTableForm', {});
    }

    render() {

        const { manageUserCostAllocationForm, manageUserCostAllocationTableForm, hasPendingApproval, isReadOnly, isReadAndExtractOnly, isReadAndWrite, } = this.props;
        const { glCodeList, costCodeList, userCostAllocation, isCostCodeLoading, hasMoreCostCode, isGlCodeLoading, hasMoreGlCode } = this.props.manageUserCostAllocation;

        const disableButton = !manageUserCostAllocationForm.GLCode || !manageUserCostAllocationForm.CostCenter || !this.state.percent;

        const sortedData = userCostAllocation.datatable.map(item => {
            return {
                ...item,
                dataItem: item.dataItem.sort((a, b) => {
                    if (a.GLCode < b.GLCode) return -1;
                    if (a.GLCode > b.GLCode) return 1;
                    if (a.GLCode === b.GLCode) {
                        if (a.CostCode < b.CostCode) return -1;
                        if (a.CostCode > b.CostCode) return 1;
                    }
                    return 0;
                }),
            };
        });


        return (
            <>
                <CustomDropdown
                    label={<Translation translationKey={"add_cost_allocation"} />}
                    activeDropdown={this.state.activeDropdown}
                    toggleActiveState={this.toggleActiveState}
                >
                    <div className="add-sim-container">
                        <div className="details-4-col-26-container">
                            <NotificationModal
                                show={this.state.showNotif}
                                title={this.state.haveError ? 'Error' : 'Success'}
                                message={this.state.modalMessage ? this.state.modalMessage : `Cost allocation ${this.state.notifTitle} successfully!`}
                                handleModal={this.handleCloseNotif}
                                customClass={'comment-notification-modal notification-footer modal-text-bold'}
                            />
                            <CustomSearchableDropdownWrapper
                                label={<Translation translationKey={"capital_gl_code"} />}
                                options={glCodeList}
                                selected={manageUserCostAllocationForm.GLCode}
                                onChange={this.OnChangeGlCode}
                                placeholder={`${this.toLocaleLanguage("select_placeholder")}`}
                                customClass={`${this.state.isExist && this.state.isAddGL_Cost ? "border-red" : ""} required`}
                                maxLength={MAX_LENGTH.limit_100}
                                fieldProp="manageUserCostAllocationForm.GLCode"
                                optionLabelKey={{
                                    Key: 'Key',
                                    Value: 'Value'
                                }}
                                

                                onSearchChange={this.handleGlCodeSearch}
                                onLoadMore={this.loadMoreGlCode}
                                isLoading={isGlCodeLoading}
                                hasMore={hasMoreGlCode}
                            />

                            <CustomSearchableDropdownWrapper
                                label={<Translation translationKey={"capital_cost_center"} />}
                                options={this.modifyOption(costCodeList)}
                                selected={manageUserCostAllocationForm.CostCenter}
                                onChange={this.OnChangeCostCenter}
                                placeholder={`${this.toLocaleLanguage("select_placeholder")}`}
                                customClass={`${this.state.isExist && this.state.isAddGL_Cost ? "border-red" : ""} required`}
                                maxLength={MAX_LENGTH.limit_100}
                                fieldProp="manageUserCostAllocationForm.CostCenter"
                                tagName='tagName'
                                optionLabelKey={{
                                    Key: 'Key',
                                    Value: 'Value'
                                }}

                                onSearchChange={this.handleCostCodeSearch}
                                onLoadMore={this.loadMoreCostCode}
                                isLoading={isCostCodeLoading}
                                hasMore={hasMoreCostCode}
                            />

                            <InputField
                                label={<Translation translationKey={"percent"} />}
                                inputValue={this.state.percent}
                                onChange={(e) => this.HandleOnChange(e, 'percent')}
                                requiredField={true}
                                customWrapper={this.state.isGreater & this.state.isAddPercent ? 'border-red' : ''}
                                placeholder={`${this.toLocaleLanguage("enter_text_placeholder")}`}
                                maxLength={MAX_LENGTH.inputText}
                            />

                            <div className="add-button-container custom-add-button">
                                <div className="btn-tooltiptext">
                                    <Button variant="outline-secondary" className="btn-custom-violet-hover-outline" onClick={this.handleCancel}>Cancel</Button>
                                    <span className="tooltip-text">{<Translation translationKey="cancel_add_cost_allocation" />}</span>
                                </div>

                                <ConfirmationNotificationModal
                                    show={this.state.showModal}
                                    message={this.state.updateCostAllocationDetails ? 'Are you sure you want to update?' : 'Are you sure you want to add?'}
                                    title={this.state.updateCostAllocationDetails ? 'Update' : 'Add'}
                                    handleModal={this.handleConfirmationModal}
                                    customClass={'comment-notification-modal modal-text-bold'}
                                />

                                <div className={'btn-tooltiptext'}>
                                    <Button
                                        disabled={(this.props.isReadOnly || this.props.isReadAndExtractOnly) ? true : hasPendingApproval ? hasPendingApproval : disableButton}
                                        onClick={this.onClickAdd}
                                        variant="primary"
                                        className="btn-add"
                                    >
                                        {`${ACTION_TYPES.Add}`}

                                    </Button>
                                    <span className="tooltip-text"><Translation translationKey="add_cost_allocation_details" /></span>
                                </div>
                            </div>
                        </div>

                        <div className="details-table-container ">

                            <TableWithButton
                                datatable={sortedData}
                                haveDeleteBtn={isReadOnly ? false : isReadAndExtractOnly ? false : true}
                                haveEditBtn={isReadOnly ? false : isReadAndExtractOnly ? false : true}
                                deleteAction={this.DeleteuserCostAllocation}
                                updateAction={this.updateUserCostAllocation}
                                handleCloseNotif={this.handleCloseNotif}
                                searchableDropdownData={["GLCode", "CostCode"]}
                                inputField={["CostCodePercent"]}
                                optionsMap={this.state.optionsMap}
                                selectedItems={manageUserCostAllocationTableForm}
                                selectedValue={this.state.selectedValue}
                                percentValue={this.props.percentValue}
                                handleSelectChange={this.handleSelectChange.bind(this)}
                                handleInputChange={this.handleInputChange.bind(this)}
                                handleOpenNotif={this.handleOpenNotif}
                                handleGetFieldData={this.handleGetFieldData.bind(this)}
                                handelEnableEdit={this.handelEnableEdit}
                                enableEdit={this.state.enableEdit}
                                keyIndex={this.state.keyIndex}
                                clearSelectedValue={this.clearSelectedValue}
                                isUpdatePercent={this.state.isUpdatePercent}
                                isGreater={this.state.isGreater}
                                isUpdateGl_Cost={this.state.isUpdateGl_Cost}
                                fieldProp="manageUserCostAllocationTableForm"

                                costAllocationForm={this.setCostAllocationForm}

                                onEditModeEnter={this.handleEditModeEnter}

                                onSearchChange={this.onTableSearchChange}
                                onLoadMore={this.onTableLoadMore}
                                isLoading={this.isTableDropDownLoading}
                                hasMore={this.hasTableDropdownMore}

                                resetTableForm={this.resetTableForm}

                            />

                            <div className="total-allocated-container">
                                <span className="allocated-label"><Translation translationKey={"total_percent_allocated"} /></span>
                                <span className={userCostAllocation.totalCostCodePercent < 100 ? "allocated-percent-less100" : "allocated-percent"}>
                                    {this.formatTotalCostCodePercent(userCostAllocation.totalCostCodePercent)}
                                </span>

                            </div>
                        </div>

                    </div>
                </CustomDropdown>
            </>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        ...bindActionCreators(
            Object.assign({}, userCostAllocationActions),
            dispatch
        ),
        FormChange: (Model, value) => {
            dispatch(actions.change(Model, value))
        }
    }
};

export default connect(
    state => {
        const { manageUserCostAllocation, translation, adminSetting } = state;
        const { manageUserCostAllocationForm, manageUserCostAllocationTableForm } = state.form;
        return {
            manageUserCostAllocation,
            manageUserCostAllocationForm,
            manageUserCostAllocationTableForm,
            adminSetting,
            ...translation
        };
    },
    mapDispatchToProps
)(AddCostAllocation);